module.exports = __webpack_public_path__ + "static/media/baby-foot.30bfef8e.png";